import { render } from "./TruckList.vue?vue&type=template&id=ef7dd556&scoped=true"
import script from "./TruckList.vue?vue&type=script&lang=js"
export * from "./TruckList.vue?vue&type=script&lang=js"

import "./TruckList.vue?vue&type=style&index=0&id=ef7dd556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7dd556"]])

export default __exports__